import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import CustomForm from 'src/components/CustomForm';
import { ADD_COMIC_FIELDS } from 'src/utils/constants';
import { Form } from 'antd';
import useWindowSize from 'src/utils/hooks//useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import comicActions from 'src/redux/actions/comicActions';
import genreSelectors from 'src/redux/selectors/genreSelectors';
import SelectedTag from 'src/components/SelectedTag';
import Loading from 'src/components/Loading';
import comicSelectors from 'src/redux/selectors/comicSelectors';

const ModalAddComic = ({ visible, onCancel, editingComic }) => {
  const dispatch = useDispatch();
  const { windowHeight } = useWindowSize();
  const [form] = Form.useForm();
  const loading = useSelector(comicSelectors.loading);
  const genresOptions = useSelector(genreSelectors.genresOptions);
  const selectedGenresOptions = genresOptions.filter(option => editingComic?.genres?.includes(option.id)).map(option => option.value);

  const fetchComics = () => {
    dispatch(comicActions.fetchComics());
  };

  useEffect(() => {
    form.setFieldsValue({
      ...editingComic,
      genres: selectedGenresOptions
    });
  }, [editingComic, visible]);

  const ASYNC_ADD_COMIC_FIELDS = ADD_COMIC_FIELDS.map(field => {
    switch (field.name) {
      case 'genres':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            options: genresOptions,
            tagRender: (props) => <SelectedTag {...props} />
          }
        };
      default:
        return field;
    }
  });

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        const selectedGenres = values.genres?.map(genre => JSON.parse(genre).id);
        const comicData = { ...values, genres: selectedGenres };
        console.log(comicData);
        if (editingComic) {
          dispatch(comicActions.editComic({ ...comicData, comicId: editingComic.id, cover: Array.isArray(values.cover) ? values.cover[0] : undefined }, () => {
            form.resetFields();
            onCancel();
            fetchComics();
          }));
        } else {
          dispatch(comicActions.addComic({ ...comicData, cover: values.cover[0] }, () => {
            form.resetFields();
            onCancel();
            fetchComics();
          }));
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  }

  return (
    <Modal
      title={editingComic ? "Edit comic" : "Add comic"}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
      centered
      bodyStyle={{ maxHeight: windowHeight - 200, overflowY: 'auto' }}
      destroyOnClose
    >
      <Loading loading={loading} />
      <CustomForm form={form} fields={ASYNC_ADD_COMIC_FIELDS} autoComplete='off' layout='vertical' />
    </Modal>
  )
}

export default ModalAddComic;